function FarmerAMCReport() {
    return (
        <div>
            <h2>Farmer AMC Report</h2>

            <p>
                Your complete information comes here.
            </p>
        </div>
    );
}

export default FarmerAMCReport;